<div class="modal-header border-bottom-0 pb-0">
    <h4 class="modal-title text-success pb-0">{{ "Form.Confirm" | translate }}</h4>
  </div>
  <div class="modal-body">
    <p class="mb-0">{{ "Form.ConfirmMessage" | translate }}</p>
  </div>
  <div class="modal-footer border-top-0">
    <button type="button" class="btn btn-outline-primary px-3" (click)="leave()">{{ "Form.Leave" | translate }}</button>
    <button type="button" class="btn btn-primary px-4" (click)="stay()" ngbAutoFocus>{{ "Form.Stay" | translate }}</button>
</div>